import React from "react";

const AboutCapitalAcres = () => {
  return (
    <section className="section shadow-sm lazyloaded" id="capitalacres">
      <div className="row">
        <div className="col-md-4">
          <span className="d-block section-heading-sub text-capitalize">
            About K-NINE REALTORS
          </span>
        </div>
        {/* <div className="col-md-8 text-right textcenter1">
          <img
            src="images/klogo.webp"
            width="150px"
            height="70px"
            loading="lazy"
            alt="logo"
          />
        </div> */}
      </div>
      <p>
        K-Nine Realtors | Your Trusted Real Estate Partner At K-Nine Realtors,
        we are committed to helping you find the perfect place to call home.
        With a team of experienced professionals, we specialize in residential,
        commercial and investment properties, delivering personalized service
        to meet the unique needs of our clients. Whether you're buying or
        Invest, our expert guidance ensures a seamless experience from start to
        finish.
      </p>
      <p>
        We believe in building long-lasting relationships through integrity,
        market expertise and client satisfaction. Let K-Nine Realtors be your
        guide to navigating the real estate market with confidence.
      </p>
    </section>
  );
};

export default AboutCapitalAcres;
